import './Services.scss';

import {Button} from "./Reusable"
import working from "../resources/images/working.webp";


function Services() {
    return (
        <>
            <div className="Services" id="services">
                <h2 className="Services-header reveal">Video Services Offered</h2>

                <div className="Services-container reveal">
                    <HeaderAndList
                        header="Nonprofit"
                        list={[
                            "Fundraising/capital campaign","Testimonials", "Mission/Story"
                        ]} />
                    <HeaderAndList
                        header="Corporate"
                        list={[
                            "Brand Anthem", "Marketing & Branding", "Testimonials / Interviews", "Recruitment / Retention", "Training"
                        ]} />
                    <HeaderAndList
                        header="Miscellaneous"
                        list={[
                            "Wedding", "Short Film", "Feature Film"
                        ]} />
                    <br />
                    <Button title="Let's talk" flameon={true} source="Services list" />
                </div>
                <img src={working} className="Services-image reveal delay-1" alt=""
                    loading="lazy" decoding="async" />
            </div>
        </>
    );
}

function HeaderAndList (props) {
    return (
        <>
        <h3>{props.header}</h3>
        <ul>
            {props.list.map(item => <li key={item}>{item}</li>)}
        </ul>
        </>
    )
}

export default Services;